export const cardDisplayValue: { [key: number]: string } = {
  11: 'J',
  12: 'Q',
  13: 'K',
  14: 'A',
};
